import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nameUniquenessValidator(names: string[], currentIndex: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentName = control.value.toLowerCase();

    const namesLength = names.length;
    for (let i = 0; i < namesLength; i++) {
      if (i === currentIndex) { continue; }

      if (currentName === names[i].toLowerCase()) {
        return { nameNotUnique: true };
      }
    }

    return null;
  };
}
